import { Image } from '@chakra-ui/react';
import React from 'react';
import logo from '@/assets/puntcity/images/logo.svg';

export default function Index() {
  return <Image src={logo} maxW="122px" ml="2" />;
}
